/**
 * Standalone entry for the server-rendered marketing pages (landing, product
 * pages, gallery, guides): starts the same interaction recorder the builder
 * uses, so a visit is recorded from the first page on. The session id lives
 * in sessionStorage, so the recording continues seamlessly into /app.
 */
import { useBuildConfig } from './stores/buildConfig.js';
import { start } from './utils/ux-recorder.js';

const go = (): void => { window.setTimeout(() => { void start(); }, 300); };
if (document.readyState === 'complete') go();
else window.addEventListener('load', go, { once: true });
// The public config (which says whether recording is on) loads asynchronously.
const unsub = useBuildConfig.subscribe((s, prev) => { if (s.ux && !prev.ux) { unsub(); go(); } });
